import { Reveal } from "./Reveal";
import { MapPin, Clock, ShieldCheck, HandHeart } from "lucide-react";

const STATS = [
  { icon: MapPin, value: "Ostrava", label: "Lokální provozovna" },
  { icon: Clock, value: "Na počkání", label: "Většina klíčů hned" },
  { icon: ShieldCheck, value: "Férově", label: "Jasná cena předem" },
  { icon: HandHeart, value: "Ochotně", label: "Poradíme s výběrem" },
];

const MARQUEE = [
  "Výroba klíčů",
  "Autoklíče",
  "Dálkové ovladače",
  "Výměna baterií",
  "Zámky a vložky",
  "Nouzové otevírání",
  "Bezpečnostní klíče",
];

export const ONas = () => {
  return (
    <section id="o-nas" data-testid="onas-section" className="relative bg-white overflow-hidden">
      {/* Editorial marquee */}
      <div className="border-y border-slate-200 bg-slate-50 py-4 overflow-hidden">
        <div className="marquee-track">
          {[...MARQUEE, ...MARQUEE].map((t, i) => (
            <span key={i} className="flex items-center">
              <span className="font-heading font-bold text-2xl sm:text-3xl text-brand-navy px-6 whitespace-nowrap">
                {t}
              </span>
              <span className="h-2 w-2 rounded-full bg-brand-orange" />
            </span>
          ))}
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-20 md:py-28">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-6">
            <Reveal>
              <p className="text-sm font-bold uppercase tracking-[0.2em] text-brand-orange mb-3">
                O nás
              </p>
              <h2 className="font-heading font-black text-4xl sm:text-5xl text-brand-navy tracking-tight leading-[1.02]">
                Lokální klíčnictví, kterému můžete věřit
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-6">
            <Reveal delay={0.1}>
              <p className="text-lg text-slate-600 leading-relaxed">
                Jsme klíčnictví přímo v Ostravě. Zaměřujeme se na výrobu klíčů a
                autoklíčů, opravy ovladačů, zámky a nouzové situace. Nejsme
                anonymní web – přijďte, zavolejte a vše vyřešíme rychle a
                srozumitelně.
              </p>
              <p className="mt-4 text-base text-slate-500 leading-relaxed">
                Záleží nám na tom, abyste od nás odcházeli spokojení. Poradíme s
                výběrem, řekneme cenu předem a většinu zakázek zvládneme na
                počkání.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-2 lg:grid-cols-4 gap-5">
          {STATS.map((s, i) => {
            const Icon = s.icon;
            return (
              <Reveal key={s.label} delay={i * 0.06}>
                <div className="rounded-2xl bg-brand-navy p-6 h-full hover:-translate-y-1 transition-transform duration-300">
                  <span className="grid place-items-center h-11 w-11 rounded-xl bg-brand-orange/15 text-brand-orange">
                    <Icon className="h-5 w-5" strokeWidth={2.2} />
                  </span>
                  <p className="mt-4 font-heading font-black text-2xl text-white">
                    {s.value}
                  </p>
                  <p className="text-sm text-slate-400 mt-0.5">{s.label}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ONas;
